export default __webpack_public_path__ + "static/0249-8526580bc62b644b47e514fc5167df18.png";